import { useGlobalStore } from '@/stores/global';
import type { InContextData } from '@/types/i18n/i18n.types';

const AUTHORIZED_PARAM = 'in-context';
const PSEUDO_LANG = 'zu-ZA';

export function launchCrowdinInContext(): false | InContextData {
  const urlParams = window.location.href.split('?')[1];

  if (useGlobalStore().getEnvironment !== 'prod' && urlParams === AUTHORIZED_PARAM) {
    const script: HTMLScriptElement = document.createElement('script');
    script.src = '//cdn.crowdin.com/jipt/jipt.js';
    document.body.append(script);

    return {
      pseudoLang: PSEUDO_LANG
    };
  }

  return false;
}
